import _Modal from "@arco-design/web-react/es/Modal";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import _Message from "@arco-design/web-react/es/Message";
import _Button from "@arco-design/web-react/es/Button";
import _Link from "@arco-design/web-react/es/Link";
import _Spin from "@arco-design/web-react/es/Spin";
import _Select from "@arco-design/web-react/es/Select";
import _Avatar from "@arco-design/web-react/es/Avatar";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useCallback, useRef, useState } from 'react';
import { IconPlus } from '@arco-design/web-react/icon';
import { useDispatch } from 'react-redux';
import debounce from 'lodash.debounce';
import style from './style.less';
import { searchUsers } from '@src/utils/api/user';
import { AddThemeOwner } from '@src/utils/api/theme';
import { quickCreateSpace } from '@src/utils/api/space';
import { isInner } from '@src/utils/env';
import { UpdateTheme } from '@api/theme';
var getOptions = function getOptions(data, author) {
  return data.map(function (user) {
    return {
      label: /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          padding: '6px 0'
        }
      }, /*#__PURE__*/React.createElement(_Avatar, {
        size: 24,
        style: {
          marginLeft: 6,
          marginRight: 12
        }
      }, /*#__PURE__*/React.createElement("img", {
        alt: "avatar",
        src: user.avatar_url
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          lineHeight: '18px'
        }
      }, user.username), /*#__PURE__*/React.createElement("p", {
        style: {
          lineHeight: '12px',
          color: 'var(--color-text-2)',
          fontSize: 12,
          padding: '2px 0'
        }
      }, user.nickname))),
      value: user.username,
      extra: user,
      disabled: user.username === author
    };
  });
};
function AddUser(props) {
  var _this = this;
  var author = props.author;
  var _a = __read(useState(props.ownerInfos || []), 2),
    UserInfos = _a[0],
    setUserInfos = _a[1];
  var _b = __read(useState(getOptions(props.ownerInfos || [], author)), 2),
    options = _b[0],
    setOptions = _b[1];
  var _c = __read(useState(false), 2),
    fetching = _c[0],
    setFetching = _c[1];
  var _d = __read(useState(false), 2),
    loading = _d[0],
    setLoading = _d[1];
  var refFetchId = useRef();
  var debouncedFetchUser = useCallback(debounce(function (inputValue) {
    if (!inputValue) {
      return;
    }
    refFetchId.current = Date.now();
    var fetchId = refFetchId.current;
    setFetching(true);
    setOptions([]);
    searchUsers({
      nameLike: inputValue
    }).then(function (data) {
      if (refFetchId.current === fetchId) {
        var options_1 = getOptions(data, author);
        setFetching(false);
        setOptions(options_1);
      }
    });
  }, 500), []);
  var error = UserInfos.length < 1;
  var linkStudio = function linkStudio() {
    return __awaiter(_this, void 0, void 0, function () {
      var data, belongSpace;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, quickCreateSpace()];
          case 1:
            data = _a.sent();
            belongSpace = {
              spaceId: data.spaceId,
              groupId: data.groups[0].groupId
            };
            return [4, UpdateTheme({
              belongSpace: belongSpace,
              themeId: props.themeId
            })];
          case 2:
            _a.sent();
            location.reload();
            return [2];
        }
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Select, {
    error: error,
    mode: "multiple",
    options: options,
    placeholder: "\u8F93\u5165\u90AE\u7BB1\u524D\u7F00\u8FDB\u884C\u641C\u7D22",
    value: UserInfos.map(function (x) {
      return x.username;
    }),
    onChange: function onChange(value, options) {
      setUserInfos(value.map(function (v) {
        var item = UserInfos.find(function (x) {
          return x && x.username === v;
        });
        if (item) {
          return item;
        }
        item = options.find(function (x) {
          return x && x.value === v;
        });
        return item && item.extra;
      }));
    },
    filterOption: false,
    renderFormat: function renderFormat(_, v) {
      var userInfo = UserInfos.find(function (x) {
        return x.username === v;
      });
      return userInfo ? /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement(_Avatar, {
        size: 20,
        style: {
          marginRight: 6
        }
      }, /*#__PURE__*/React.createElement("img", {
        alt: "avatar",
        src: userInfo.avatar_url
      })), userInfo.username) : v;
    },
    notFoundContent: fetching ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/React.createElement(_Spin, {
      style: {
        margin: 12
      }
    })) : null,
    onSearch: debouncedFetchUser
  }), error && /*#__PURE__*/React.createElement("p", {
    style: {
      color: 'rgb(var(--danger-6))',
      fontSize: 12
    }
  }, "\u81F3\u5C11\u4E00\u4E2A\u7BA1\u7406\u5458"), isInner && /*#__PURE__*/React.createElement("p", {
    className: style['adduser-tip']
  }, "\u4E00\u952E\u5173\u8054\u81F3 ", /*#__PURE__*/React.createElement(_Link, {
    onClick: linkStudio
  }, "ArcoStudio"), "\uFF0C\u4F53\u9A8C\u591A\u5E73\u53F0\u8D44\u6E90\u4E00\u7AD9\u5F0F\u7BA1\u7406\u3002", /*#__PURE__*/React.createElement(_Link, {
    href: "/studio"
  }, "\u7ACB\u5373\u4F53\u9A8C")), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    disabled: error || loading,
    type: "primary",
    onClick: function onClick() {
      return __awaiter(_this, void 0, void 0, function () {
        var newTheme, _1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setLoading(true);
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              return [4, AddThemeOwner({
                themeId: props.themeId,
                owners: UserInfos.map(function (x) {
                  return x.username;
                })
              })];
            case 2:
              newTheme = _a.sent();
              _Message.info('操作成功');
              props.onOk(newTheme);
              return [3, 4];
            case 3:
              _1 = _a.sent();
              setLoading(false);
              return [3, 4];
            case 4:
              return [2];
          }
        });
      });
    }
  }, "\u786E\u5B9A")));
}
export default function AddOwner(props) {
  var _a, _b;
  var themeInfo = props.themeInfo,
    readonly = props.readonly;
  var dispatch = useDispatch();
  var spaceId = isInner ? (_a = themeInfo.belongSpace) === null || _a === void 0 ? void 0 : _a.spaceId : '';
  var userInfos = isInner ? ((_b = themeInfo.belongSpace) === null || _b === void 0 ? void 0 : _b.userInfos) || [] : [];
  return /*#__PURE__*/React.createElement(_Avatar.Group, {
    size: 26,
    maxCount: 7
  }, isInner && spaceId && userInfos.length ? userInfos.map(function (item) {
    return /*#__PURE__*/React.createElement(_Tooltip, {
      content: item.name,
      key: item.username
    }, /*#__PURE__*/React.createElement(_Avatar, null, /*#__PURE__*/React.createElement("img", {
      src: item.avatarurl
    })));
  }) : themeInfo.ownerInfos.map(function (item) {
    return /*#__PURE__*/React.createElement(_Tooltip, {
      content: item.name,
      key: item.id
    }, /*#__PURE__*/React.createElement(_Avatar, null, /*#__PURE__*/React.createElement("img", {
      src: item.avatar_url
    })));
  }), !readonly && /*#__PURE__*/React.createElement(_Avatar, {
    className: style['nav-actions-owner'],
    onClick: function onClick() {
      var modal = _Modal.info({
        title: '添加协作者',
        closable: false,
        maskClosable: false,
        focusLock: false,
        onCancel: function onCancel() {
          modal.close();
        },
        content: spaceId ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
          style: {
            textAlign: 'center'
          }
        }, "\u5F53\u524D\u4E3B\u9898\u5DF2\u5173\u8054\u81F3Arco studio\u3010" + themeInfo.belongSpace.name + "\u3011\u56E2\u961F"), /*#__PURE__*/React.createElement("p", {
          style: {
            textAlign: 'center'
          }
        }, " \u8BF7\u524D\u5F80\u56E2\u961F\u8BBE\u7F6E\u7BA1\u7406\u56E2\u961F\u534F\u4F5C\u6210\u5458\u3002")) : /*#__PURE__*/React.createElement(AddUser, {
          author: themeInfo.author,
          themeId: themeInfo.themeId,
          onOk: function onOk(newTheme) {
            dispatch({
              type: 'updateThemeConfig',
              payload: newTheme
            });
            modal.close();
          },
          ownerInfos: themeInfo.ownerInfos
        }),
        footer: spaceId ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Button, {
          style: {
            marginRight: 8
          },
          onClick: function onClick() {
            modal.close();
          }
        }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(_Button, {
          type: "primary",
          onClick: function onClick() {
            window.open("/studio/spaces/" + spaceId + "/team?spaceId=" + spaceId);
          }
        }, "\u524D\u5F80\u8BBE\u7F6E")) : null
      });
    }
  }, /*#__PURE__*/React.createElement(IconPlus, null)));
}